import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { themeGet } from '@styled-system/theme-get';

import Text from '../../../../shared/Text/Text';

import { EmailPreview } from './EmailPreview.jsx';
import { SmsPreview } from '../../shared/SmsPreview.jsx';
import { Badge } from '../../../../shared/Badge/Badge';

export const BothPreview = ({ values, emailCount, smsCount }) => {
  const { t } = useTranslation('broadcasts');
  const { emailBody, subject, smsBody } = values;

  return (
    <Container>
      <PreviewHeader>
        <EmailHeader>
          <Header>
            <EmailIcon />
            <Text variant="subtitle2">{t('reviewStep.emailPreview')}</Text>
          </Header>
          <Badge variant="grey">
            <Trans>
              {t('reviewStep.recipientCount', { count: emailCount })}
            </Trans>
          </Badge>
        </EmailHeader>
        <SmsHeader>
          <Header>
            <SmsIcon />
            <Text variant="subtitle2">{t('reviewStep.smsPreview')}</Text>
          </Header>
          <Badge variant="grey">
            <Trans>{t('reviewStep.recipientCount', { count: smsCount })}</Trans>
          </Badge>
        </SmsHeader>
      </PreviewHeader>
      <PreviewContainer>
        <EmailPreviewWrapper>
          <EmailPreview
            emailBody={emailBody}
            subject={subject}
            uuid={values.uuid}
          />
        </EmailPreviewWrapper>
        <SmsPreviewWrapper>
          <SmsPreview
            message={smsBody}
            title={subject}
            downloadable={Boolean(values.uuid)}
          />
        </SmsPreviewWrapper>
      </PreviewContainer>
    </Container>
  );
};

// The letter is 603px wide plus gutters, so half of the 1040px page
// squeezes it. The phone is a fixed ~290px and fits in what's left.
const EMAIL_WIDTH = '60%';
const SMS_WIDTH = '40%';

const Container = styled.div``;

const PreviewContainer = styled.div`
  display: flex;
`;

const SmsPreviewWrapper = styled.div`
  width: ${SMS_WIDTH};
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
`;

const EmailPreviewWrapper = styled.div`
  width: ${EMAIL_WIDTH};
  border-right: 1px solid ${themeGet('colors.black.10')};
  display: flex;
  flex-direction: column;
`;

const EmailHeader = styled.div`
  border-right: 1px solid ${themeGet('colors.black.10')};
  width: ${EMAIL_WIDTH};
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SmsHeader = styled(EmailHeader)`
  width: ${SMS_WIDTH};
`;

const PreviewHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
`;

const Header = styled.div``;

const EmailIcon = styled.i.attrs({ className: 'fa-regular fa-envelope' })`
  margin-right: 5px;
`;

const SmsIcon = styled.i.attrs({ className: 'fa-regular fa-message-lines' })`
  margin-right: 5px;
`;
